<template>
  <gadget-base @hide="hideWidget" v-loading="isLoading">
    <div class="chart pie">
      <h3>カテゴリー別出数</h3>
      <div class="chart_wrap" v-show="data.length">
        <canvas id="chart_1_2" ref="canvas"></canvas>
      </div>
      <div v-show="!data.length">
        データなし
      </div>
    </div>
  </gadget-base>
</template>

<script>
import { mapGetters } from 'vuex'

import GadgetBase from './GadgetBase'
import Chart from 'chart.js'
import addFigure from '@/misc/addFigure'

export default {
  name: 'CategorySalesPieChartGadget',
  props: {
    targetDate: {
      type: Object,
      required: true,
    },
  },
  watch: {
    targetDate (val) {
      this.fetchData()
    },
  },
  data () {
    return {
      isLoading: true,
      _chart: null,
      data: [],
    }
  },
  computed: {
    ...mapGetters('report', ['pieColors']),
    graphData () {
      return this.data.map(x => x.count)
    },
    graphLabel () {
      return this.data.map(x => x.label)
    },
    graphColor () {
      return this.data.map(x => x.color)
    },
    graphSum () {
      let sum = 0
      this.graphData.map(x => { sum += x })
      return sum
    },
  },
  methods: {
    fetchData () {
      this.isLoading = true
      this.$request.reports.categories(this.targetDate.format('YYYY-MM-DD')).then(res => {
        let data = []
        // 最後は小計なのでスキップ
        res.body = res.body.slice(0, res.body.length - 1)
        res.body.sort((a, b) => {
          if (!a.data.cloudCategorySlug) {
            return 1
          } else if (!b.data.cloudCategorySlug) {
            return -1
          }
          return a.data.cloudCategorySlug < b.data.cloudCategorySlug ? 1 : -1
        })
        res.body.forEach((x, index) => {
          let colorIndex = index % this.pieColors.length
          data.push({
            label: x.data.categoryName,
            count: x.data.itemCount,
            sales: x.data.sales,
            color: this.pieColors[colorIndex],
          })
        })

        this.data = data
        this.createChart()
      }).finally(() => {
        this.isLoading = false
      })
    },
    createChart () {
      let data = {
        labels: this.graphLabel,
        datasets: [{
          backgroundColor: this.graphColor,
          borderWidth: 1,
          data: this.graphData,
        }],
      }
      if (this._chart) {
        this._chart.data = data
        this._chart.update()
        return
      }
      let self = this
      this._chart = new Chart(
        this.$refs.canvas.getContext('2d'), {
          type: 'pie',
          data: data,
          options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: true,
              position: 'right',
              labels: {
                fontSize: 10,
                padding: 5,
                boxWidth: 10,
              },
            },
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  return data.labels[tooltipItem.index] +
                    ': ' +
                    addFigure(data.datasets[0].data[tooltipItem.index]) +
                    ' (' +
                    Math.round(data.datasets[0].data[tooltipItem.index] / self.graphSum * 100) +
                    ' %)'
                },
              },
            },
          },
        }
      )
    },
    hideWidget () {
      this.$emit('hide')
    },
  },
  mounted () {
    this.fetchData()
  },
  components: {
    GadgetBase,
  },
}
</script>

<style scoped>
div.chart {
  padding: 5px;
}

.chart h3 {
  font-size: 14px;
  font-weight: normal;
}

.chart_wrap {
  width: 100%;
  height: 280px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/CategoryCountPieChart.vue